import React, { useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Dropdown from 'components/dropdown';
import {
  faCog,
  faCopy,
  faDownload,
  faEdit,
  faFileCsv,
  faFileExcel,
  faTag,
  faTrash
} from '@fortawesome/pro-solid-svg-icons';

import { connect } from 'react-redux';
import {
  deleteShadow,
  duplicateShadow,
  exportShadow,
  selectShadow,
  updateShadow,
} from 'components/shadow_grid/shadows/store/shadows/actions';

import confirm from 'components/confirm';
import UnstyledDropdownToggle from 'components/bootstrap_extensions/unstyled_dropdown_toggle';
import { RenameModal } from '../rename_modal';

export function ShadowRowActions({
  canExportShadows,
  deleteShadow,
  duplicateShadow,
  exportShadow,
  selectShadow,
  shadow,
  updateShadow
}) {
  const [show, setShow] = useState(false);

  const showDownload = useMemo(() => {
    return canExportShadows && (!shadow.internal || shadow.public);
  }, [canExportShadows, shadow]);

  async function confirmDeletion() {
    try {
      await confirm('Are you sure you want to delete this grid?', {
        buttonLabel: 'Delete',
        buttonStyle: 'danger',
        title: 'Delete Grid',
      });

      deleteShadow(shadow);
    } catch (e) {
      // Nothing to do
    }
  }

  const handleRename = (name) => {
    updateShadow(shadow, { name });
    setShow(false);
  };

  async function handleExport(asCsv) {
    await exportShadow(shadow, asCsv);
  }

  return (
    <React.Fragment>
      <Dropdown
        className="list-item-actions-dropdown"
        id={`shadow-${shadow.id}`}
        pullRight
      >
        <UnstyledDropdownToggle bsRole="toggle">
          <FontAwesomeIcon
            className="text-muted clickable"
            icon={faCog}
            size="lg"
          />
        </UnstyledDropdownToggle>
        <Dropdown.Menu>
          <Dropdown.MenuItems>
            <Dropdown.MenuItem name="edit" onClick={() => selectShadow(shadow)}>
              <FontAwesomeIcon icon={faEdit} /> Edit
            </Dropdown.MenuItem>
            <Dropdown.MenuItem name="rename" onClick={() => setShow(true)}>
              <FontAwesomeIcon icon={faTag} /> Rename
            </Dropdown.MenuItem>
            <Dropdown.MenuItem name="duplicate" onClick={() => duplicateShadow(shadow)}>
              <FontAwesomeIcon icon={faCopy} /> Duplicate
            </Dropdown.MenuItem>
            {showDownload ? (
              <Dropdown.ParentItem icon={faDownload} key="download" label="Download" name="download">
                <Dropdown.MenuItem name="excel" onClick={() => handleExport(false)}>
                  <FontAwesomeIcon icon={faFileExcel} /> Excel
                </Dropdown.MenuItem>
                <Dropdown.MenuItem name="csv" onClick={() => handleExport(true)}>
                  <FontAwesomeIcon icon={faFileCsv} /> CSV
                </Dropdown.MenuItem>
              </Dropdown.ParentItem>
            ) : []}
            <Dropdown.MenuItem name="delete" onClick={confirmDeletion}>
              <FontAwesomeIcon icon={faTrash} /> Delete
            </Dropdown.MenuItem>
          </Dropdown.MenuItems>
        </Dropdown.Menu>
      </Dropdown>
      {
        show && (
          <RenameModal
            shadow={shadow}
            onClose={() => setShow(false)}
            onRename={handleRename}
          />
        )
      }
    </React.Fragment>
  );
}

ShadowRowActions.propTypes = {
  canExportShadows: PropTypes.bool,
  deleteShadow: PropTypes.func.isRequired,
  duplicateShadow: PropTypes.func.isRequired,
  exportShadow: PropTypes.func.isRequired,
  selectShadow: PropTypes.func.isRequired,
  shadow: PropTypes.shape({
    id: PropTypes.number.isRequired,
  }).isRequired,
  updateShadow: PropTypes.func.isRequired,
};

const mapStateToProps = ({ canExportShadows }) => ({
  canExportShadows
});

const mapDispatchToProps = {
  deleteShadow,
  duplicateShadow,
  exportShadow,
  selectShadow,
  updateShadow,
};

export default connect(mapStateToProps, mapDispatchToProps)(ShadowRowActions);
